import { render, staticRenderFns } from "./AutomaticReading.vue?vue&type=template&id=2e46ca4c&scoped=true"
import script from "./AutomaticReading.vue?vue&type=script&lang=js"
export * from "./AutomaticReading.vue?vue&type=script&lang=js"
import style0 from "./AutomaticReading.vue?vue&type=style&index=0&id=2e46ca4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e46ca4c",
  null
  
)

export default component.exports